let bannerElement = false;
let showTimeout = null;

const hideMessage = () => {
	if (!bannerElement) return;

	if (showTimeout) {
		clearTimeout(showTimeout);
		showTimeout = null;
	}

	bannerElement.classList.remove('is-showing');
	bannerElement.setAttribute('aria-live', 'off');
};

const showMessage = (message, type = 'error', instant = 0) => {
	bannerElement = document.querySelector('[data-banner]');
	if (!bannerElement) return;

	const messageElement = bannerElement.querySelector('[data-message]');
	const dismissElement = bannerElement.querySelector('[data-dismiss]');
	if (!messageElement || !dismissElement) return;

	hideMessage();

	bannerElement.dataset.banner = type;
	messageElement.textContent = message;

	showTimeout = setTimeout(() => {
		bannerElement.classList.add('is-showing');
		bannerElement.setAttribute('aria-live', 'assertive');
		showTimeout = null;
	}, instant);

	dismissElement.removeEventListener('click', hideMessage);
	dismissElement.addEventListener('click', hideMessage);
};

export { showMessage, hideMessage };
